<template>
    <div class="group relative h-12 w-full overflow-hidden bg-white border-2 border-indigo-500 rounded-full">
        <select
          :value="modelValue"
          @change="$emit('update:modelValue', $event.target.value)"
          class="w-full h-full px-4 text-sm font-bold appearance-none outline-hidden border-0 cursor-pointer"
        >
            <option v-for="option in options" :value="option.id">{{ option.title }}</option>
        </select>
        <span
          class="absolute top-1/2 right-0 mr-5 transform -translate-y-1/2 text-black group-hover:text-indigo-500">
            <Chevron class="rotate-90 h-3"/>
        </span>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import Chevron from '@/Components/Svg/Chevron.vue';

export default defineComponent({
    components: { Chevron },
    props: {
        options: Array,
        modelValue: {
            required: true,
        },
    }
})
</script>
